//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
import { AppContext } from '../../common/contexts';
import { PATH_DASHBOARD } from '../../system/constants';
// import { AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { BASE_URL, DASHBOARD_ID_MY_SETTINGS, GO_TO_MY_DASHBOARD, GO_TO_MY_SETTINGS, SEND_EMAIL_AGAIN, USER_TYPE_JS } from '../../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdLink from '../../common/elemental/AfitdLink';
import AfitdButton from '../../common/elemental/AfitdButton';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import CloseIcon from '@material-ui/icons/Close';
import LockOpenIcon from '@material-ui/icons/LockOpen';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: { marginTop: 50 },
    sendEmailAgainLink: { textDecoration: 'underline', fontWeight: 'bold' },
    title: { fontWeight: 'bold', fontSize: 26, marginTop: 40, marginBottom: 16, [theme.breakpoints.down('sm')]: { marginTop: 30 } },
    message: { textAlign: 'center', marginBottom: 40, [theme.breakpoints.down('sm')]: { marginBottom: 24 } },
    content: { textAlign: 'center' },
    sendEmailAgainLinkText: { marginTop: 24 },
    mainIcon: { fontSize: 93, color: 'rgba(216, 216, 216, 1)' },
    secondIcon: { background: 'rgba(255, 81, 81, 1)', color: '#fff', borderRadius: '50%', fontSize: 28, padding: 2, marginLeft: ' -30px', marginTop: '55px' },
    iconContainer: { display: 'flex', justifyContent: 'center' },
    passwordMainIcon: { fontSize: 93, color: 'rgba(216, 216, 216, 1)' },
    passwordCloseIcon: { background: 'rgba(255, 81, 81, 1)', color: '#fff', borderRadius: '50%', fontSize: 28, padding: 2, marginLeft: ' -31px', marginTop: '64px' },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        // props,
        isJs,
        handleClickResendButton,
        handleClickGoToMySettingsButton,
    } = params;

    const defns = {
        root: { container: true, justify: 'center' },
        content: { item: true, xl: 10, lg: 10, md: 10, sm: 10, xs: 10 },
        title: { variant: 'h5', clsSkinnyBold: true /* clsLightBold: true */ },
        message: { variant: 'body1' },
        needAnotherLinkText: { variant: 'body1', component: 'span' },
        sendEmailAgainLinkText: { variant: 'body1', component: 'p' },
        sendEmailAgainLink: {
            color: 'secondary',
            onClick: handleClickResendButton,
            label: SEND_EMAIL_AGAIN,
        },
        goToMySettingsButton: {
            variant: 'contained',
            color: 'secondary',
            label: isJs ? GO_TO_MY_DASHBOARD : GO_TO_MY_SETTINGS,
            onClick: handleClickGoToMySettingsButton,
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const ActionCodeFailed = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    const appContext = useContext(AppContext);
    const { currentUser } = appContext;
    // const context = useContext(LayoutContext);

    const isJs = _get(currentUser, 'type') === USER_TYPE_JS;

    const history = useHistory();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { emailVerificationFailed, emailVerificationFailedInvalidCode, resetPasswordFailed } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [homePageId, setHomePageId] = useState(HOMEPAGE_LANDING);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleClickResendButton = async () => {
        alert('(Fake) Email sent! It might take up to 10 minutes for it to arrive your inbox.');
    };

    const handleClickGoToMySettingsButton = async () => {
        history.push(`${BASE_URL}${PATH_DASHBOARD}/${DASHBOARD_ID_MY_SETTINGS}`);
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, isJs, handleClickResendButton, handleClickGoToMySettingsButton });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <>
            {emailVerificationFailed && (
                <Grid {...defns.root}>
                    <Grid {...defns.content}>
                        <div {...defns.iconContainer}>
                            <MailOutlineIcon {...defns.mainIcon} />
                            <CloseIcon {...defns.secondIcon} />
                        </div>
                        <AfitdTypography {...defns.title}>Email Verification Unsuccessful</AfitdTypography>
                        <AfitdTypography {...defns.message}>Unfortunately, we could not verify your email address.</AfitdTypography>
                        <AfitdTypography {...defns.needAnotherLinkText}>Need Another Verification Link?</AfitdTypography>
                        <AfitdTypography {...defns.sendEmailAgainLinkText}>
                            <AfitdLink {...defns.sendEmailAgainLink} />
                        </AfitdTypography>
                    </Grid>
                </Grid>
            )}
            {emailVerificationFailedInvalidCode && (
                <>
                    <AfitdTypography {...defns.title}>Invalid Verification Link</AfitdTypography>
                    <AfitdTypography {...defns.message}>
                        Your email verification link has expired or is invalid. However, your email address on file has already been verified.
                    </AfitdTypography>
                    <AfitdButton {...defns.goToMySettingsButton}>Go To My Settings</AfitdButton>
                </>
            )}
            {resetPasswordFailed && (
                <Grid {...defns.root}>
                    <Grid {...defns.content}>
                        <div {...defns.iconContainer}>
                            <LockOpenIcon {...defns.passwordMainIcon} />
                            <CloseIcon {...defns.passwordCloseIcon} />
                        </div>
                        <AfitdTypography {...defns.title}>Password Reset Unsuccessful</AfitdTypography>
                        <AfitdTypography {...defns.message}>Unfortunately, we could not reset your password.</AfitdTypography>
                        <AfitdTypography {...defns.needAnotherLinkText}>Need Another Password Reset Link?</AfitdTypography>
                        <AfitdTypography {...defns.sendEmailAgainLinkText}>
                            <AfitdLink {...defns.sendEmailAgainLink} />
                        </AfitdTypography>
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default ActionCodeFailed;
